import { currentWorkspace, useMe } from '../../lib/session'

export function useWs(): string {
  const me = useMe()
  return currentWorkspace(me.data) ?? ''
}

export function useRole(): string {
  const me = useMe()
  const ws = currentWorkspace(me.data)
  return me.data?.memberships.find((m) => m.workspaceId === ws)?.role ?? 'viewer'
}
